<script setup lang="ts">
import type { OfferChangeSummary } from '../offer-change-stats';
defineProps<{ summary: OfferChangeSummary }>();
</script>
<template>
  <section
    class="offer-changes"
    aria-labelledby="offer-changes-title"
    data-testid="offer-change-stats"
  >
    <h3 id="offer-changes-title">Changements d’offre</h3>
    <p>
      Demandes sur la période sélectionnée, y compris les commandes déjà livrées. Une commande
      peut comporter plusieurs demandes.
    </p>
    <div class="change-cards">
      <article v-for="direction in ['upgrades', 'downgrades'] as const" :key="direction">
        <h4>
          {{
            direction === 'upgrades'
              ? 'Vers une offre plus chère'
              : 'Vers une offre moins chère'
          }}
        </h4>
        <strong class="change-total">{{ summary[direction].requested }}</strong>
        <span>demande(s)</span>
        <dl>
          <div>
            <dt>Confirmées</dt>
            <dd>{{ summary[direction].applied }}</dd>
          </div>
          <div>
            <dt>Non retenues</dt>
            <dd>{{ summary[direction].notRetained }}</dd>
          </div>
          <div>
            <dt>En attente</dt>
            <dd>{{ summary[direction].pending }}</dd>
          </div>
        </dl>
      </article>
    </div>
    <p>
      « Non retenues » regroupe les refus et abandons. Ces nombres mesurent la demande, pas le
      chiffre d’affaires. Le filtre Offre retient l’offre de départ ou d’arrivée.
    </p>
    <details v-if="summary.pairs.length">
      <summary>Voir les offres concernées</summary>
      <ul>
        <li v-for="(pair, index) in summary.pairs" :key="index">
          <strong>{{ pair.from }} → {{ pair.to }}</strong>
          <span
            >{{ pair.requested }} demandée(s) · {{ pair.applied }} confirmée(s) ·
            {{ pair.notRetained }} non retenue(s) · {{ pair.pending }} en attente</span
          >
        </li>
      </ul>
    </details>
  </section>
</template>
<style scoped>
.offer-changes {
  margin: 1.5rem 0;
  overflow-wrap: anywhere;
}
.offer-changes p {
  font-size: 0.9rem;
  color: #475569;
}
.change-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
}
.change-cards article {
  padding: 0.9rem;
  border: 1px solid #cbd5e1;
  border-radius: 1rem;
  background: #f8fafc;
}
h4 {
  margin: 0 0 0.5rem;
  font-size: 1rem;
}
.change-total {
  display: block;
  font-size: 2rem;
  color: #20214f;
}
dl {
  margin: 0.75rem 0 0;
}
dl div {
  display: flex;
  justify-content: space-between;
  gap: 0.3rem;
  font-size: 0.85rem;
}
dd {
  margin: 0;
  font-weight: 700;
}
summary {
  cursor: pointer;
  font-weight: 700;
}
ul {
  list-style: none;
  padding: 0;
}
li {
  padding: 0.75rem 0;
  border-bottom: 1px solid #e2e8f0;
}
li span {
  display: block;
  font-size: 0.85rem;
}
</style>
